import script from "./BlogPostCardLarge.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogPostCardLarge.vue?vue&type=script&setup=true&lang=js"

import "./BlogPostCardLarge.vue?vue&type=style&index=0&id=3dc567c8&lang=scss"

const __exports__ = script;

export default __exports__